import { getAllLegalMoves } from "../utils/logic"


export function getMoveRandom(board, turn){
    let legal = getAllLegalMoves(board, turn)    
    return legal[Math.floor(Math.random()*legal.length)]//xInit; yInit; xFinal; yFinal
}